import { Button, ButtonColors, ButtonSizes } from "@inno-ui/button";
import { CheckmarkIcon } from "@inno-ui/icons";
import { useStore } from "@tanstack/react-form";

import { useFormContext } from "../../hooks/use-form";

type SubmitButtonProps = {
  label: string;
};

export function SubmitButton({ label }: SubmitButtonProps) {
  const form = useFormContext();
  const [isSubmitting] = useStore(form.store, state => [state.isSubmitting]);

  return (
    <Button
      type="submit"
      label={label}
      isLoading={isSubmitting}
      width="100%"
      color={ButtonColors.Green}
      icon={CheckmarkIcon}
      size={ButtonSizes.L}
    />
  );
}
